import React, { useEffect, useRef } from 'react';
import withStyles from 'react-jss';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';

const dashboardModalStyling = {
  horizontalLineColor: (props) => ({
    border: `3px solid ${props.tenant.secondary}`,
  }),
  buttonColor: (props) => ({
    backgroundColor: props.tenant.primary,
    borderColor: props.tenant.primary,

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.tenant.primary}`,
      color: props.tenant.primary,
      borderStyle: 'solid',
    },
  }),
};

function DashboardModal(props) {
  const { showModal, handleCloseModal } = { ...props };
  const wrapperRef = useRef(null);

  const { t } = useTranslation();

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          if (showModal) handleCloseModal();
        }
      }

      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };

  useOutsideAlerter(wrapperRef);

  return (
    <div className="dashboard-modal">
      <div className="modal-content top" ref={wrapperRef}>
        {props.location.pathname.includes('user-profile') ? (
          <p>{t(`They haven't favorited any careers yet.`)}</p>
        ) : (
          <p>{t('You haven’t favorited any careers yet.')}</p>
        )}
      </div>
      {!props.location.pathname.includes('user-profile') && (
        <div className="modal-content bottom" ref={wrapperRef}>
          <Link to="career-search">
            <button
              className={[
                'button--primary dashboard-favorites-button',
                props.classes.buttonColor,
              ].join(' ')}
              id="submit"
              type="submit"
            >
              {t('Explore Careers')}
            </button>
          </Link>
        </div>
      )}
    </div>
  );
}

export default withRouter(withStyles(dashboardModalStyling)(DashboardModal));
